import { z } from 'zod'

export const AvatarSchema = z.object({
  profilePhotoUrl: z.string().optional(),
  initials: z.string(),
  backgroundColor: z
    .string()
    .transform(hex => (hex.startsWith('#') ? hex : `#${hex}`)),
})
